import { GraphPayload } from '../types'

export const getAverageData = (data?: GraphPayload) =>
  data ? data.reduce((a, b) => a + Number(b.value), 0) / data.length : undefined
